import styled from "styled-components";
import {
	FONT_WT_BOLD,
	FONT_WT_LIGHT,
	FONT_SIZE_16,
	COLOR_WHITE,
} from "@website-builder/utilities-index";

export const CTAButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	.cta-button {
		align-self: center;
		color: ${COLOR_WHITE};
		background-color: var(--secondary);
		max-width: 90%;
		min-width: 130px;
		padding: 12px 24px;
		margin-bottom: 18px;
		font-size: ${FONT_SIZE_16};
		font-weight: ${FONT_WT_BOLD};
		border: 0;
		border-radius: 3px;
		cursor: pointer;
		font-weight: ${FONT_WT_LIGHT};
	}
`;
